import React from "react";
import { useNavigate } from "react-router-dom";
import { Radio, Play, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRoom } from "@/context/RoomContext";

export default function ResumeRoomCard() {
  const navigate = useNavigate();
  const { activeRoom, setOpenLobby } = useRoom();
  if (!activeRoom) return null;
  const count = (activeRoom.members || []).filter((m) => m.role !== "spectator").length;

  return (
    <div className="rounded-2xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 to-transparent p-4 mb-6 flex items-center gap-3 flex-wrap" data-testid="resume-room-card">
      <div className="text-3xl shrink-0">{activeRoom.game_cover || "🎮"}</div>
      <div className="flex-1 min-w-[180px]">
        <div className="flex items-center gap-1.5 text-xs font-semibold text-emerald-500"><Radio className="w-3.5 h-3.5" /> You're in a live room</div>
        <div className="font-display font-bold truncate">{activeRoom.game_title}</div>
        <div className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-2">
          <span className="font-mono tracking-widest text-[hsl(var(--foreground))]">{activeRoom.code}</span>
          <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {count}</span>
        </div>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" className="rounded-full" onClick={() => setOpenLobby(true)} data-testid="resume-open-lobby">Open lobby</Button>
        <Button size="sm" className="rounded-full gap-1.5" onClick={() => navigate(`/app/coop/${activeRoom.id}`)} data-testid="resume-play-together"><Play className="w-4 h-4" /> Play together</Button>
      </div>
    </div>
  );
}
